/**
 * @desc 根据系统单号列表和商品行编号列表获取订单包裹列表Item
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.listBySpItemNosAndSonos.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackageItem/listBySpItemNosAndSonos`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
